/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
// Redux Toolkit
import { useSelector } from "react-redux";
import { selectUser } from "../../store/userSlice";
import authRoles from "../../auth/authRoles";
// Framer Motion
import { motion } from "framer-motion";
// BASE Components
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../@BASE/core/NavLinkAdapter";
// Material-UI
import Button from "@mui/material/Button";
import Input from "@mui/material/Input";
import Paper from '@mui/material/Paper';
import Typography from "@mui/material/Typography";

function ListingHeader(props) {
  const {resource, searchTerm, setSearchTerm} = props;
  const user = useSelector(selectUser);

  return (
    <div className="p-24 sm:p-32 sm:py-64 w-full">
      <div className="flex flex-col md:flex-row md:items-center">
        <motion.div
          className="grow"
          initial={{ x: -20, opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
        >
          <div className="flex items-center mb-8">
            <Typography className="text-20 md:text-24 font-semibold">
              {resource}
            </Typography>
          </div>
          <Paper
            component={motion.div}
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1, transition: { delay: 0.2 } }}
            className="flex flex-1 w-full sm:max-w-256 items-center space-x-8 px-0 rounded-none shadow-0 mr-auto"
            sx={{
              backgroundColor: 'background.royalBlue',
              color: 'common.white',
              borderBottom: 'solid 1px'
            }}
          >
            <BASESvgIcon size={20}>
              heroicons-outline:search
            </BASESvgIcon>

            <Input
              placeholder={"Search " + resource.toLowerCase()}
              className="flex flex-1 text-white"
              disableUnderline
              color="secondary"
              fullWidth
              value={searchTerm}
              inputProps={{
                "aria-label": "Search",
              }}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </Paper>
        </motion.div>
        {(authRoles.admin.includes(user.role)) && (
          <motion.div
            className="flex-none"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0, transition: { delay: 0.2 } }}
          >
            <Button
              className="ml-8"
              variant="contained"
              component={NavLinkAdapter}
              to="new/edit"
              sx={{
                backgroundColor: 'common.white',
                color: 'primary.dark',
              }}
            >
              <BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>
              <span className="mx-8">Add</span>
            </Button>
          </motion.div>
        )}
      </div>
    </div>
  );
}

export default ListingHeader;
